import { l as lodash } from './lodash-5c867657.js';

const removeEmphasis = (s) => {
    let newString = lodash.replace(s, /<em>/g, '');
    newString = lodash.replace(newString, /\<\/em\>/g, '');
    return newString;
};

const typeaheadUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    removeEmphasis: removeEmphasis
});

export { removeEmphasis as r, typeaheadUtils as t };
